import { useContext } from 'react';
import UploadResultsContext, { UploadResultsContextValue } from '../../context/UploadResultsContext';

function useUploadResults() {
  const { uploadResults, dispatch, uploadData } = useContext(UploadResultsContext) as UploadResultsContextValue;

  return { uploadResults, dispatch, uploadData };
}

export default useUploadResults;
